import { Box, Paper, Stack, Typography } from "@mui/material";
import type { ReactNode } from "react";

export interface PanelProps {
  title?: string;
  subtitle?: string;
  toolbar?: ReactNode;
  children?: ReactNode;
}

export function Panel({ title, subtitle, toolbar, children }: PanelProps) {
  return (
    <Paper
      elevation={0}
      sx={{
        p: 2,
        display: "flex",
        flexDirection: "column",
        gap: 1.5,
        height: "fit-content",
      }}
    >
      {(title || subtitle || toolbar) && (
        <Stack direction="row" alignItems="flex-start" spacing={1.5} sx={{ mb: 0.5 }}>
          <Box sx={{ flex: 1, minWidth: 0 }}>
            {title && (
              <Typography variant="subtitle1" noWrap>
                {title}
              </Typography>
            )}
            {subtitle && (
              <Typography variant="body2" sx={{ opacity: 0.7 }} noWrap>
                {subtitle}
              </Typography>
            )}
          </Box>
          {toolbar && <Box sx={{ flexShrink: 0 }}>{toolbar}</Box>}
        </Stack>
      )}
      <Box sx={{ height: "fit-content" }}>{children}</Box>
    </Paper>
  );
}
